"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_INCLUDED_STANDARD_FIELDS = exports.DATE_FIELDS = exports.BOOLEAN_FIELDS = exports.ID_FIELDS = void 0;
const filter_model_1 = require("./filter.model");
const State = __importStar(require("../../../store/state"));
exports.ID_FIELDS = [
    filter_model_1.FilterField.Category,
    filter_model_1.FilterField.TaxonomyClass,
    filter_model_1.FilterField.Attribute,
    State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_ID,
    State.PRODUCT_EDITOR_TABLE_COLUMNS.CLASS,
    State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_GROUP,
    filter_model_1.FilterField.Value,
];
exports.BOOLEAN_FIELDS = [State.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS];
exports.DATE_FIELDS = [filter_model_1.FilterField.DateCreated, filter_model_1.FilterField.DateUpdated, filter_model_1.FilterField.DateLastCommented];
exports.NOT_INCLUDED_STANDARD_FIELDS = [
    State.PRODUCT_EDITOR_TABLE_COLUMNS.IMAGE,
    State.PRODUCT_EDITOR_TABLE_COLUMNS.CREATED_DATE,
    State.PRODUCT_EDITOR_TABLE_COLUMNS.LAST_MODIFIED,
];
